import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

import {
  APIHandler,
  StorageHandler,
  DataHandler,
  SharingPopup,
} from 'C4';
import { storageKeys } from 'settings';
import { renderToString } from 'react-dom/server';

import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logo: null,
      image: null,
      userStatus: 'startTraining',
      chapter: 0,
      appId: 0,
      lastPage: 0,
      showCaseId: 0,
      email: '',
      loading: true,
      twitterShare: '',
      shareTitle: '',
      shareContent: '',
      videoEmailCopy: '',
      videoEmailSubject: '',
      imageEmailCopy: '',
      imageEmailSubject: '',
      backgroundImage: '',
      parentLogo: '',
      parentName: '',
      parentUrl: '',
      splashScreen: '',
    };
  }

  setAnnouncements = async () => {
    const appId = await DataHandler.matchAppId();
    const res = await APIHandler.getAnnouncement(appId);
    if (res.length !== 0) {
      const ToastContent = () => {
        const { message } = res[0];
        let weburl = '';
        if (res[0] && res[0].weblink) {
          weburl = res[0].weblink;
        }

        return (
          <div>
            <p>
              <a href={weburl} key="toast" target="_blank">
                <span dangerouslySetInnerHTML={{ __html: message }} />
              </a>
            </p>
          </div>
        );
      };

      toast.info(ToastContent, {
        position: 'top-center',
        autoClose: false,
        closeOnClick: false,
        transition: Zoom,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
        toastId: 'announcement',
      });
    
      return null;
    }
  };

  componentDidMount() {
    this.getProgress();
    this.getShowcase();
    this.setAnnouncements();

    document.body.classList.add('no-scroll');

    const d = new Date(Date.now());
    const leading = val => `0${val}`.slice(-2);

    StorageHandler.load(storageKeys.user).then((user) => {
      if (!user) {
        window.location.replace("/login");
      }
      if (user && user.sales_companion_registered === null) {
        const obj = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        });
      }
    });

    this.getAppInfo();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  async getProgress() {
    // Always register user progress first
    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      await APIHandler.registerUserProgress(user.email);
      const appId = await DataHandler.matchAppId();
      const app = await APIHandler.getUserProgress(appId, user.email);
      if (app && app.data && app.data[0].chapters) {
        const { chapter } = app.data[0].chapters[0];

        let lastPage = 0;
        let userStatus = 'startTraining';
        if (app.data[0].chapters[0].progress >= (app.data[0].chapters[0].total_pages - 1)) {
          lastPage = 0;
          userStatus = 'graduated';
        } else {
          lastPage = app.data[0].chapters[0].progress;
        }

        // Get chapter id + progress in chapter
        this.setState({
          chapter, lastPage, userStatus, email: user.email, loading: false,
        });
      }
    }
  }

  async getShowcase() {
    const appId = await DataHandler.matchAppId();
    const showcase = await APIHandler.getExhibitionStands(appId);
    if (showcase && showcase[0] && showcase[0].tiles && showcase[0].tiles[0] && showcase[0].tiles[0].company_id) {
      this.setState({ showCaseId: showcase[0].tiles[0].company_id, appId });
    }
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWideWhite,
        image: `${appInfo.backgroundImage}`,
        twitterShare: appInfo.shareTitle,
        shareTitle: appInfo.shareTitle,
        shareContent: appInfo.shareContent,
        videoEmailCopy: appInfo.videoEmailCopy,
        videoEmailSubject: appInfo.videoEmailSubject,
        imageEmailCopy: appInfo.imageEmailCopy,
        imageEmailSubject: appInfo.imageEmailSubject,
        backgroundImage: appInfo.backgroundImage,
        splashScreen: appInfo.splashScreen
      });
      if (appInfo.darkTheme === 1) {
        this.setState({
          logo: appInfo.logoWide,
        });
      }
    }
    const parentApp = await StorageHandler.load(storageKeys.parentApp);
    if (parentApp) {
      this.setState({
        parentLogo: parentApp[0].logo_wide_white,
        parentName: parentApp[0].programName,
        parentUrl: parentApp[0].website_url
      });
      if (appInfo.darkTheme === 1) {
        this.setState({
          parentLogo: parentApp[0].logo_wide_color,
        });
      }
    }
  }

  render() {
    const {
      image,
      logo,
      userStatus,
      chapter,
      lastPage,
      showCaseId,
      email,
      loading,
      appId,
      twitterShare,
      shareTitle,
      shareContent,
      videoEmailCopy,
      videoEmailSubject,
      imageEmailCopy,
      imageEmailSubject,
      backgroundImage,
      parentLogo,
      parentName,
      parentUrl,
      splashScreen,
    } = this.state;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['share', 'close'],
      share: {
        tpl: renderToString(<SharingPopup 
          url={`https://travproconnect.com/profile_consumer/${showCaseId}?lang=en&email=${email}&app_id=${appId}&share_hide=true`} 
          twitterShare={twitterShare}
          shareTitle={shareTitle}
          shareContent={shareContent}
          videoEmailCopy={videoEmailCopy}
          videoEmailSubject={videoEmailSubject}
          imageEmailCopy={imageEmailCopy}
          imageEmailSubject={imageEmailSubject}
          backgroundImage={splashScreen}
          />),
      },
    };

    return (
      <div className="homeContainer">
        {!loading && <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {props => (
            <div className="homeView" style={props}>
               {parentName === '' && <div className="qrCode">
                  <a href="https://thesource.travel" target="_blank" rel="noopener noreferrer">
                    <img src="https://front.travpromobile.com/760/qr.png" alt="QR Code" />
                  </a>
              </div>}
              <div className="homeView__title">
                <img src={logo} className="homeLogo" alt="logo" />
                <div className="centerImage">
                  <img src={splashScreen} alt="Product" />
                  {userStatus !== 'graduated' &&
                    <Link to={`/main/training/chapter/${chapter}/${lastPage}`}>
                      <button className="left">
                        <FontAwesomeIcon icon={['fal', 'graduation-cap']} />
                        MicroLearning Module
                      </button>
                    </Link>}
                  {userStatus === 'graduated' && 
                  <Link to={`/main/ret/chapter/${chapter}/0`}>
                    <button className="left">
                      <FontAwesomeIcon icon={['fal', 'book-reader']} />
                      <span>Review &amp; Retain</span>
                    </button>
                  </Link>}
                  <a 
                    data-fancybox="showcase"
                    data-type="iframe"
                    data-src={`https://travproconnect.com/profile/${showCaseId}?lang=en&email=${email}&app_id=${appId}&share_hide=true`}
                    href={`https://travproconnect.com/profile/${showCaseId}?lang=en&email=${email}&app_id=${appId}&share_hide=true`}
                    key="showcase"
                    data-options={JSON.stringify(fancyOptions)}
                  >
                    <button className="right">
                      <FontAwesomeIcon icon={['fal', 'megaphone']} />
                      Marketing Showcase
                    </button>
                  </a>
                </div>
                {parentName !== '' && <div className="parentLogo">
                  <a href={`${parentUrl}/main/training`}>
                    <img src={parentLogo} alt="Logo" />
                  </a>
                </div>}
              </div>
            </div>
          )}
        </Spring>}
        {parentName === '' && <div className="bottomLine">
          <a href="https://thesource.travel" target="_blank" rel="noopener noreferrer">
            MicroLearning &amp; Marketing for Travel Advisors Powered by TheSOURCE
          </a>
        </div>}
        {parentName !== '' && <div className="bottomLineMicro">
          <a href={`${parentUrl}/main/training`}>
            {parentName} MicroLearning Partner
          </a>
        </div>}
        <ToastContainer
          draggablePercent={60}
          autoClose={false}
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
      </div>
    );
  }
}
